import type { ResultOf } from "@graphql-typed-document-node/core";
import { safe, ErrorADT } from "pb.safe";

import {
	$,
	query,
	TransactionStatus,
	TransactionType,
} from "../../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../../shared/shared/api-client";

// import { ClientError } from "graphql-request";

export type Transactions = Exclude<
	Awaited<ReturnType<typeof getTransactions>>,
	Error
>["transactions"];

export async function getTransactions({
	apiClient,
	deviceId,
	purchaseId,
}: {
	apiClient: ApiClient;
	deviceId: string;
	purchaseId: string;
}): Promise<
	| ResultOf<typeof getTransactions.gql.getTransactions>["getTransactions"]
	| ErrorADT<"NetworkFailure">
	// | ErrorADT<"NetworkFailure" | "NotFound">
> {
	const response = await safe(() =>
		apiClient.request(getTransactions.gql.getTransactions, {
			deviceUuid: deviceId,
			limit: 50,
			filter: {
				externalReference: { eq: purchaseId },
				type: {
					in: [TransactionType.PURCHASE, TransactionType.PURCHASEADVICE],
				},
				status: {
					eq: TransactionStatus.APPROVED,
				},
				timestamp: {
					gt: new Date(
						Date.now() - 31 * 24 * 60 * 60 * 1000 /* 31 days */,
					).toISOString(),
				},
			},
		}),
	);
	if (response instanceof Error) {
		// if (response instanceof ClientError) {
		// const error = response.response.errors?.[0] as
		//   | { errorType?: string }
		//   | undefined;
		// if (error?.errorType === "NOT_FOUND") {
		//   return ErrorADT("NotFound");
		// }
		// } else if (response.message.includes("Transaction not found")) {
		//   return ErrorADT("NotFound");
		// }
		return ErrorADT("NetworkFailure");
		// } else if (!response.getTransactions.transactions.length) {
		//   return ErrorADT("NotFound");
	}
	return response.getTransactions;
}

getTransactions.gql = {
	getTransactions: query("getTransactions", (q) => [
		q.getTransactions(
			{
				deviceUuid: $("deviceUuid"),
				limit: $("limit"),
				filter: $("filter"),
				nextToken: $("nextToken"),
			},
			(c) => [
				c.nextToken((n) => [n.entityUuid, n.id, n.type]),
				c.transactions((t) => [
					t.amount,
					t.currency,
					t.cardMedia,
					t.externalReference,
					t.id,
					t.isoProcessingCode,
					t.maskedPan,
					t.reference,
					t.refundedAmount,
					t.scheme,
					t.timestamp,
					t.type,
					t.refundTransactions((r) => [
						r.amount,
						r.currency,
						r.cardMedia,
						r.externalReference,
						r.id,
						r.maskedPan,
						r.reference,
						r.refundedAmount,
						r.status,
						r.scheme,
						r.timestamp,
						r.type,
					]),
				]),
			],
		),
	]),
};
